import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Qué formato tiene?',
  a: 'La colección completa se entrega en formato digital (PDF de alta calidad). Podrás descargar todos los manuales y bonus inmediatamente después de tu compra para leerlos en cualquier dispositivo o imprimirlos.'
}, {
  q: '¿Puedo verlo desde celular?',
  a: 'Sí, absolutamente. Los documentos están optimizados para ser leídos cómodamente desde tu celular, tablet o computadora. Podrás llevarlos contigo al taller o a la obra.'
}, {
  q: '¿Es para principiantes?',
  a: 'Sí. El Nivel 1 está diseñado específicamente para quienes empiezan desde cero. Te enseñamos los fundamentos, herramientas necesarias y primeros pasos antes de avanzar a proyectos más complejos.'
}, {
  q: '¿Incluye proyectos reales?',
  a: 'Sí, la colección incluye planos, despieces y el paso a paso de proyectos reales (puertas, ventanas, cerramientos) para que puedas aplicar lo aprendido inmediatamente.'
}, {
  q: '¿Recibo los bonus?',
  a: 'Sí, al acceder hoy a la oferta especial recibirás los 3 niveles más los 5 bonus exclusivos detallados en esta página sin ningún costo adicional.'
}, {
  q: '¿Obtengo acceso inmediato?',
  a: 'Sí. Una vez procesado el pago, recibirás un correo electrónico con el enlace de descarga directa a todo el material. El acceso es de por vida.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section id="faq" className="py-24 relative" data-id="element-61">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-63">
          <h2 className="text-4xl md:text-5xl font-bold font-heading mb-6" data-id="element-64">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-65">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="glass-panel rounded-2xl overflow-hidden" data-id="element-66">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/5 transition-colors" data-id="element-67">
                <span className="font-semibold text-lg text-white/90 pr-8" data-id="element-68">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#2F80ED] transition-transform duration-300 shrink-0 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-69" />
              </button>

              <AnimatePresence data-id="element-70">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-71">
                    <div className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-72">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}